import { render, staticRenderFns } from "./SettingsTabImport.vue?vue&type=template&id=42652988&"
import script from "./SettingsTabImport.vue?vue&type=script&lang=js&"
export * from "./SettingsTabImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports